import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import call from '../../service';
import { setBookShip } from '../../store/actions/action';
import DataTable from 'react-data-table-component';
import columnsPublicShips from '../dataTablesColumsMap/publicShipsListColumns';
import customStyles from '../dataTablesColumsMap/customTableCss';

const PublicShipsListing = ({ userTokenDetails, bookShip, setBookShip, dispatch }) => {

  const [filterData, setFilterData] = useState({})

  const userTypeId = userTokenDetails.type_id ? userTokenDetails.type_id : null
  const userEmail = userTokenDetails.email ? userTokenDetails.email : null
  const userId = userTokenDetails.user_id ? userTokenDetails.user_id : null

  //---------------------------------------------------------------------------------------------------------------------
  // use effects
  useEffect(() => {
    //------------------------------------------------------------------

    //------------------------------------------------------------------

    //------------------------------------------------------------------
    //API Calls
    fetchTableData(1, { userId: userId, type_id: userTypeId })
    //------------------------------------------------------------------

  }, [filterData, bookShip.info.refresh]);



  //---------------------------------------------------------------------------------------------------------------------
  // datatable
  const [tableData, settableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [searchKey, setsearchKey] = useState("")
  // const [statusFilter, setstatusFilter] = useState(0)

  function fetchTableData(page, inptObject) {
    setLoading(true);
    let objectAPI = {
      "currentPage": page,
      "resultPerPage": perPage,
      "userId": inptObject.userId ? inptObject.userId : userId,
      "type_id": inptObject.type_id ? inptObject.type_id : userTypeId,
      "gridOnly": true
    }

    objectAPI = { ...objectAPI, ...filterData }

    call('POST', 'getpublicshipslist', objectAPI).then((result) => {
      console.log('running getpublicshipslist api-->', result);
      settableData(formatDataFortable(result.shipdata, objectAPI.userId))
      setTotalRows(result.countdata.totalCount)

      setLoading(false);
    }).catch((e) => {
      console.log('error in getpublicshipslist', e);
      setLoading(false);
    })
  }

  const handlePageChange = page => {
    fetchTableData(page, {});
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setLoading(true);
    setPerPage(newPerPage);
    let objectAPI = {
      "currentPage": page,
      "resultPerPage": newPerPage,
      "userId": userId,
      "type_id": userTypeId,
      "gridOnly": true
    }

    objectAPI = { ...objectAPI, ...filterData }

    call('POST', 'getpublicshipslist', objectAPI).then((result) => {
      console.log('running getpublicshipslist api-->', result);
      settableData(formatDataFortable(result.shipdata, objectAPI.userId))
      setTotalRows(result.countdata.totalCount)

      setLoading(false);
    }).catch((e) => {
      console.log('error in getpublicshipslist', e);
      setLoading(false);
    })
  };

  const handleSort = (column, sortDirection) => {
    setFilterData({
      ...filterData,
      "sortColum": column.selector,
      "sortDirection": sortDirection
    })
  };


  function formatDataFortable(dataArray, userId) {
    let resultArray = []
    for (let i = 0; i < dataArray.length; i++) {
      let tempObj = {}

      tempObj.ship_name = dataArray[i].ship_name
      tempObj.type = dataArray[i].type
      tempObj.category = dataArray[i].category
      tempObj.imo_no = dataArray[i].imo_no
      tempObj.ship_status = dataArray[i].availability === 3 ? "Booked" :
        dataArray[i].availability === 2 ? "Pending" :
          dataArray[i].availability === 1 ? "Available" :
            dataArray[i].availability === 0 ? "Not-Available" : ""
      tempObj.commodities = dataArray[i].commodities
      tempObj.registry_port = dataArray[i].registry_port
      tempObj.lengthv = dataArray[i].lengthv
      tempObj.breadthv = dataArray[i].breadthv
      tempObj.depth = dataArray[i].depth
      tempObj.dead_weight = dataArray[i].dead_weight
      tempObj.gross = dataArray[i].gross
      tempObj.net = dataArray[i].net
      tempObj.action = dataArray[i].availability === 2 ?
        <button type="button" className="btn btn-primary btn-sm" title="Book Ship" onClick={() => setBookShip(true, { value: dataArray[i] })} >
          <i class="fa fa-ship" aria-hidden="true"></i>
        </button> : "Booked"

      resultArray.push(tempObj)
    }
    return resultArray
  }

  //---------------------------------------------------------------------------------------------------------------------


  //---------------------------------------------------------------------------------------------------------------------
  //Filters

  const filterState = (event) => {
    setFilterData({
      ...filterData,
      [event.target.name]: event.target.value
    })
  };

  // const filterStateButtons = (type) => {
  //   if (type === 3) {
  //     setFilterData({
  //       ...filterData,
  //       onlyPilot: false,
  //       onlyComplete: true
  //     })
  //   } else if (type === 2) {
  //     setFilterData({
  //       ...filterData,
  //       onlyPilot: false,
  //       onlyProgress: true,
  //       onlyComplete: false
  //     })${dbResult[i].registry_port ? dbResult[i].registry_port : "NA"},
  //       onlyPilot: true,
  //       onlyProgress: false,
  //       onlyComplete: false
  //     })
  //   }
  // };

  const reset = () => {
    // setstatusFilter(0)
    setFilterData({})
    document.getElementById("searchInput").value = ''
    document.getElementById("searchFromdate").value = ''
    document.getElementById("searchTodate").value = ''
    setsearchKey("")
  }

  const handleKeyPress = (event) => {
    event.persist();
    if (event.keyCode === 13) {
      setFilterData({
        ...filterData,
        "search": searchKey
      })
    }
  };
  //---------------------------------------------------------------------------------------------------------------------


  //---------------------------------------------------------------------------------------------------------------------
  // functions
  function ExportTableCSV() {

    let objectAPI = {
      "currentPage": 1,
      "resultPerPage": totalRows,
      "userId": userId,
      "type_id": userTypeId,
      "gridOnly": true
    }

    objectAPI = { ...objectAPI, ...filterData }

    call('POST', 'getpublicshipslist', objectAPI).then((result) => {
      console.log('running getpublicshipslist api-->', result);

      const dbResult = result.shipdata
      let csvString = "Ship Name,Type,Category,Imo No,Ship Status,Commodities,Registry Port,Length,Breadth,Depth,Deadweight,Gross Ton,Net Ton\r\n"

      for (let i = 0; i < dbResult.length; i++) {
        let rowString = `${dbResult[i].ship_name},
        ${dbResult[i].type ? dbResult[i].type : "NA"},
        ${dbResult[i].category ? dbResult[i].category : "NA"},
        ${dbResult[i].imo_no ? dbResult[i].imo_no : "NA"},
        ${dbResult[i].availability === 3 ? "Booked" :
            dbResult[i].availability === 2 ? "Pending" :
              dbResult[i].availability === 1 ? "Available" :
                dbResult[i].availability === 0 ? "Not-Available" : ""},
        ${dbResult[i].commodities ? dbResult[i].commodities.replace(/,/g, " ") : "NA"},
        ${dbResult[i].registry_port ? dbResult[i].registry_port : "NA"},
        ${dbResult[i].lengthv ? dbResult[i].lengthv : "NA"},
        ${dbResult[i].breadthv ? dbResult[i].breadthv : "NA"},
        ${dbResult[i].depth ? dbResult[i].depth : "NA"},
        ${dbResult[i].dead_weight ? dbResult[i].dead_weight : "NA"},
        ${dbResult[i].gross ? dbResult[i].gross : "NA"},
        ${dbResult[i].net ? dbResult[i].net : "NA"}\r\n`

        rowString = rowString.replace(/(\n)/gm, "")
        csvString += rowString
      }
      let link = document.createElement('a');
      link.style.display = 'none';
      link.setAttribute('target', '_blank');
      link.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvString));
      link.setAttribute('download', `Trade_Contracts_${userEmail.split('@')[0]}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    }).catch((e) => {
      console.log('error in getpublicshipslist', e);
    })
  }
  //---------------------------------------------------------------------------------------------------------------------


  return (
    <>
      <div className="d-md-flex mt-3 mb-3">
        <div className="filter-bg">
          <ul>
            {/* <li className={"pilot-cont cursor-pointer " + (statusFilter === 1 ? "shadow" : '')} id="progessButton" onClick={() => { setstatusFilter(1); filterStateButtons(1) }}>
              <span className="icon"><img src="assets/images/filter-icon.svg" /></span>Not-Available
            			</li> */}
            <li className="complete-cont shadow" id="statusFilter" >
              <span className="icon"><img src="assets/images/filter-icon.svg" /></span>Available
                  </li>
            {/* <li className={"progress-cont cursor-pointer " + (statusFilter === 3 ? "shadow" : '')} id="statusFilter" onClick={() => { setstatusFilter(3); filterStateButtons(3) }}>
              <span className="icon"><img src="assets/images/filter-icon.svg" /></span>Pending
                  </li>
            <li className={"primary-cont cursor-pointer " + (statusFilter === 4 ? "shadow" : '')} id="statusFilter" onClick={() => { setstatusFilter(4); filterStateButtons(4) }}>
              <span className="icon"><img src="assets/images/filter-icon.svg" /></span>Booked
                  </li> */}
          </ul>
        </div>

        <div className="ml-md-auto relative">
          {/* {(Object.keys(filterData).length) ? <div className="reset" onClick={() => reset()}>reset</div> : ''} */}
          <ul className="range-slider">
            <li>
              <input name="search" placeholder="Search" value={searchKey} onChange={(event) => { setsearchKey(event.target.value) }} id="searchInput" onKeyDown={handleKeyPress} />
              <button type="button" onClick={() => {
                setFilterData({
                  ...filterData,
                  "search": searchKey
                })
              }}><i class="fas fa-search fa-lg"></i></button>
            </li>
            <li>
              <label>From</label>
              <input type="date" name="fromDate" value={filterData.fromDate} onChange={filterState} id="searchFromdate" />
            </li>
            <li>
              <label>To</label>
              <input type="date" name="toDate" value={filterData.toDate} onChange={filterState} id="searchTodate" />
            </li>
            <li><input type="button" value="Reset" className="btn btn-danger btn-sm" onClick={() => reset()} /></li>
          </ul>
        </div>
      </div>
      <div className="table-responsive">
        <DataTable
          columns={columnsPublicShips}
          data={tableData}
          progressPending={loading}
          pagination
          progressComponent={<img width="100px" src="assets/images/loader.gif" alt="description" />}
          persistTableHead
          striped
          noHeader
          paginationServer
          paginationTotalRows={totalRows}
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={handlePageChange}
          highlightOnHover
          onSort={handleSort}
          sortServer
          customStyles={customStyles}
        />
      </div>
      <hr />
      <div className="float-left col-md-6 ">
        <div className="col-md-12 row">
          <div className="col-md-6">
            <button className=" text-center btn btn-primary btn-sm m-0" onClick={() => ExportTableCSV()}>
              <i class="fas fa-file-csv"></i> Export CSV
              </button>
          </div>
        </div>
      </div>
    </>)
}

//---------------------------------------------------------------------------------------------------------------------
// Redux
const mapStateToProps = state => {
  return {
    bookShip: state.bookShip
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setBookShip: (flag, data) => { dispatch(setBookShip({ modal: flag, info: data })) }
  }
}
//---------------------------------------------------------------------------------------------------------------------

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PublicShipsListing)
